export { Typography } from "./components/Typography";